import script from "./TutorialCategoryPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TutorialCategoryPage.vue?vue&type=script&setup=true&lang=js"

import "./TutorialCategoryPage.vue?vue&type=style&index=0&id=aaf7218c&lang=css"

const __exports__ = script;

export default __exports__